export class NodeBatch {
    expandable: boolean = false;
    expanded: boolean = false;
    checked: boolean = false;
    active: boolean = false;
    disabled: boolean = false;
}
